/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const UserInfoResponseR = t.interface({
  name: t.string,

  familyName: t.string
});

// optional attributes
const UserInfoResponseO = t.partial({});

export const UserInfoResponse = t.intersection(
  [UserInfoResponseR, UserInfoResponseO],
  "UserInfoResponse"
);

export type UserInfoResponse = t.TypeOf<typeof UserInfoResponse>;
